export enum CandidateSignalStatus {
  OnTrack = 0,
  InProgress = 1,
  Attention = 2,
}
